export default __webpack_public_path__ + "static/media/clock.dd8dc0f5.svg";